import { Color, Vec3 as PcVec3 } from 'playcanvas';
import type { ShortcutId } from '../../submodules/supersplat-viewer/src/types';
import type { VrQualityPreset } from '@mindcloudxai/shared';

export type { PcVec3 };

export const ENABLED_SHORTCUTS: ShortcutId[] = ['reset', 'playPause'];

export const AVATAR_FALL_DROP_THRESHOLD = 8;
export const AVATAR_FALL_MIN_AIRBORNE_SECONDS = 1.2;
export const AVATAR_FALL_MIN_VELOCITY_Y = -2;
export const AVATAR_FALL_RESET_COOLDOWN_SECONDS = 1.5;

// XR 性能档位配置：控制 framebufferScale、splatBudget、fixedFoveation。
// 立体渲染逐帧开销翻倍（左右眼各一遍 splat 排序+光栅），需按设备 GPU 能力选择档位。
// 参考设备：Quest 3 → medium，Quest Pro → low，Vision Pro → high。
export interface VrQualityConfig {
  framebufferScale: number;
  splatBudget: number;
  fixedFoveation: number;
}

const VR_QUALITY_PRESETS: Record<VrQualityPreset, VrQualityConfig> = {
  lowest: { framebufferScale: 0.4, splatBudget: 300_000, fixedFoveation: 1 },
  low: { framebufferScale: 0.5, splatBudget: 500_000, fixedFoveation: 1 },
  medium: { framebufferScale: 0.6, splatBudget: 800_000, fixedFoveation: 0.8 },
  high: { framebufferScale: 0.7, splatBudget: 1_200_000, fixedFoveation: 0.5 },
  higher: { framebufferScale: 0.8, splatBudget: 1_500_000, fixedFoveation: 0.3 },
  highest: { framebufferScale: 1.0, splatBudget: 2_000_000, fixedFoveation: 0 },
};

export function resolveVrQualityConfig(preset: VrQualityPreset): VrQualityConfig {
  return VR_QUALITY_PRESETS[preset] ?? VR_QUALITY_PRESETS.medium;
}

// projectPoint 复用的临时向量，避免每次调用分配
export const tmpWorld = new PcVec3();
export const tmpView = new PcVec3();
export const tmpScreen = new PcVec3();

export const TRACK_ROUTE_COLOR = new Color(1, 0.35, 0.05, 1);
export const TRACK_KEYFRAME_COLOR = new Color(0.1, 0.9, 1, 1);
